// extracted by mini-css-extract-plugin
export default {"loginForm":"login_loginForm__lHBAz"};